<template>
  <!-- Content Wrapper-->
  <div class="content-wrapper">
    <AsideBar />
    <div class="content-header">
      <div
        class="d-flex justify-space-between align-items-center"
        style="border-bottom: 1px solid #00000017; height: 66px"
      >
        <div class="col pl-0">
          <div>
            <div
              class="spinner-border text-primary loading-spinner"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <h1 class="m-0 text-dark" v-else>
              {{ getDomainUrl($route.params.id) }}
            </h1>
          </div>
          <ol class="breadcrumb float-sm-left">
            <router-link tag="li" class="breadcrumb-item" :to="{ name: 'Home' }"
              >Home</router-link
            >
            <router-link
              tag="li"
              class="breadcrumb-item"
              :to="{ name: 'Dashboard' }"
              >Dashboard</router-link
            >
            <router-link
              tag="li"
              class="breadcrumb-item"
              :to="{ name: 'MainCont' }"
              >Website Dashboard</router-link
            >
            <li class="breadcrumb-item active">More Info</li>
          </ol>
        </div>
        <router-link
          tag="div"
          :to="{ name: 'Compare' }"
          class="col d-flex justify-end pb-0 pr-0"
        >
          <v-btn color="primary" class="btn-compare">
            <svg
              width="20"
              height="16"
              viewBox="0 0 20 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-right: 7px"
            >
              <path
                d="M6.125 15.1041L4.8125 13.7708L7 11.5833H0.875V9.68748H7L4.8125 7.49998L6.125 6.16665L10.625 10.625L6.125 15.1041ZM13.875 9.83331L9.39583 5.35415L13.875 0.895813L15.1875 2.20831L13.0417 4.41665H19.1458V6.31248H13.0417L15.1875 8.49998L13.875 9.83331Z"
                fill="white"
              />
            </svg>
            <span>Compare</span>
          </v-btn>
        </router-link>
      </div>
    </div>
    <div class="content-more-info">
      <!-- Left content -->
      <div class="mi-left">
        <!-- Date Picker -->
        <div class="datepiker-row">
          <div class="datepiker-col">
            <date-picker
              v-model="datePicker"
              type="date"
              :disabled="loading"
              range
              placeholder="Select date"
            ></date-picker>
          </div>

          <div class="d-flex justify-content-end">
            <v-btn
              text
              class="border"
              :class="[dateRange === 'day' ? 'active border-primary' : '']"
              :loading="loading"
              value="day"
              @click="dateRange = 'day'"
            >
              Day
            </v-btn>
            <v-btn
              text
              class="border"
              :class="[dateRange === 'week' ? 'active border-primary' : '']"
              :loading="loading"
              value="week"
              @click="dateRange = 'week'"
            >
              Week
            </v-btn>
            <v-btn
              text
              class="border"
              :class="[dateRange === 'month' ? 'active border-primary' : '']"
              :loading="loading"
              value="month"
              @click="dateRange = 'month'"
            >
              Month
            </v-btn>
            <v-btn text color="grey" class="d-none btn-mi-filter" disabled>
              <v-icon> mdi-filter-variant </v-icon>
            </v-btn>
          </div>
        </div>

        <!-- Select-row -->
        <!-- <div class="select-row d-flex justify-space-between align-items-center">
          <v-btn text color="grey">
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.00001 18.05C7.56668 18.05 7.19585 17.8958 6.88751 17.5875C6.57918 17.2792 6.42501 16.9083 6.42501 16.475V10.7L0.600012 3.22499C0.250012 2.75832 0.200012 2.25832 0.450012 1.72499C0.700012 1.19165 1.12501 0.924988 1.72501 0.924988H16.275C16.875 0.924988 17.3 1.19165 17.55 1.72499C17.8 2.25832 17.7583 2.75832 17.425 3.22499L11.6 10.7V16.675C11.6 17.075 11.4667 17.4042 11.2 17.6625C10.9333 17.9208 10.5917 18.05 10.175 18.05H8.00001ZM9.00001 10.25L14.55 3.22499H3.47501L9.00001 10.25Z"
                fill="#7F7F7F"
              />
            </svg>
          </v-btn>
          <v-subheader v-text="'Token 1'"></v-subheader>
          <v-select :items="items" label="1990284" dense solo></v-select>
          <v-btn text color="grey" outlined>
            <svg
              width="16"
              height="15"
              viewBox="0 0 16 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.225 14.925L0.574997 13.275L6.35 7.50001L0.574997 1.72501L2.225 0.0750122L8 5.85001L13.775 0.0750122L15.425 1.72501L9.65 7.50001L15.425 13.275L13.775 14.925L8 9.15001L2.225 14.925Z"
                fill="#7F7F7F"
              />
            </svg>
          </v-btn>
        </div> -->

        <!-- <div class="select-row d-flex justify-space-between align-items-center">
          <v-btn text color="grey">
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.00001 18.05C7.56668 18.05 7.19585 17.8958 6.88751 17.5875C6.57918 17.2792 6.42501 16.9083 6.42501 16.475V10.7L0.600012 3.22499C0.250012 2.75832 0.200012 2.25832 0.450012 1.72499C0.700012 1.19165 1.12501 0.924988 1.72501 0.924988H16.275C16.875 0.924988 17.3 1.19165 17.55 1.72499C17.8 2.25832 17.7583 2.75832 17.425 3.22499L11.6 10.7V16.675C11.6 17.075 11.4667 17.4042 11.2 17.6625C10.9333 17.9208 10.5917 18.05 10.175 18.05H8.00001ZM9.00001 10.25L14.55 3.22499H3.47501L9.00001 10.25Z"
                fill="#7F7F7F"
              />
            </svg>
          </v-btn>
          <v-subheader v-text="'Token 4'"></v-subheader>
          <v-select :items="items" label="Exoclick" dense solo></v-select>
          <v-btn text color="grey" outlined>
            <svg
              width="16"
              height="15"
              viewBox="0 0 16 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.225 14.925L0.574997 13.275L6.35 7.50001L0.574997 1.72501L2.225 0.0750122L8 5.85001L13.775 0.0750122L15.425 1.72501L9.65 7.50001L15.425 13.275L13.775 14.925L8 9.15001L2.225 14.925Z"
                fill="#7F7F7F"
              />
            </svg>
          </v-btn>
        </div> -->

        <!-- Subs row-->
        <div class="subs-row">
          <div class="subs-card">
            <div class="title d-flex justify-center align-items-center">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-right: 10px"
              >
                <path
                  d="M7.33335 7.49998C9.17502 7.49998 10.6667 6.00831 10.6667 4.16665C10.6667 2.32498 9.17502 0.833313 7.33335 0.833313C5.49169 0.833313 4.00002 2.32498 4.00002 4.16665C4.00002 6.00831 5.49169 7.49998 7.33335 7.49998ZM7.33335 9.16665C5.10835 9.16665 0.666687 10.2833 0.666687 12.5V14.1666H14V12.5C14 10.2833 9.55835 9.16665 7.33335 9.16665Z"
                  fill="#3171B3"
                />
              </svg>
              Subscribers
            </div>
            <div
              class="spinner-border text-primary loading-spinner"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div v-else class="value">{{ formatNumber(subscribers.subs) }}</div>
          </div>
          <div class="subs-card">
            <div class="title d-flex justify-center align-items-center">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-right: 8.5px"
              >
                <path
                  d="M17.5208 18.7917L15.5 16.7917H2.87501V14.375C2.87501 13.7778 3.03126 13.25 3.34376 12.7917C3.65626 12.3334 4.06945 11.9861 4.58334 11.75C5.3889 11.375 6.16668 11.0868 6.91668 10.8854C7.66668 10.684 8.43751 10.5625 9.22918 10.5209L0.708344 1.97919L1.70834 0.979187L18.5208 17.7917L17.5208 18.7917ZM15.3958 11.75C15.8958 11.9306 16.2986 12.2327 16.6042 12.6563C16.9097 13.0799 17.0764 13.5764 17.1042 14.1459V14.3125L13.9583 11.1667C14.1945 11.25 14.434 11.3438 14.6771 11.4479C14.9201 11.5521 15.1597 11.6528 15.3958 11.75ZM11.6667 8.87502L6.77084 3.95835C7.06251 3.34724 7.50348 2.87849 8.09376 2.5521C8.68404 2.22571 9.31945 2.06252 10 2.06252C11 2.06252 11.8507 2.40627 12.5521 3.09377C13.2535 3.78127 13.6042 4.63196 13.6042 5.64585C13.6042 6.32641 13.4375 6.95835 13.1042 7.54169C12.7708 8.12502 12.2917 8.56946 11.6667 8.87502Z"
                  fill="#3171B3"
                />
              </svg>
              Unsubscribers
            </div>
            <div
              class="spinner-border text-primary loading-spinner"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else>
              {{ formatNumber(subscribers.unsubs) }}
            </div>
          </div>
          <div class="subs-card">
            <div class="title d-flex justify-center align-items-center">
              <svg
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-right: 7px"
              >
                <path
                  d="M17.2709 18.9167L14.375 16V16.7917H0.125015V14.375C0.125015 13.7917 0.270849 13.2674 0.562515 12.8021C0.854182 12.3368 1.27085 11.9861 1.81252 11.75C2.85418 11.3056 3.79515 10.9792 4.63543 10.7708C5.47571 10.5625 6.34029 10.4583 7.22918 10.4583C7.54863 10.4583 7.85071 10.4757 8.13543 10.5104C8.42015 10.5451 8.70835 10.5972 9.00002 10.6667L7.50002 9.125C7.40279 9.15278 7.30904 9.17014 7.21877 9.17708C7.12849 9.18403 7.03474 9.1875 6.93752 9.1875C6.0764 9.13194 5.38196 8.84375 4.85418 8.32292C4.3264 7.80208 4.02779 7.11111 3.95835 6.25C3.95835 6.13889 3.96182 6.03472 3.96877 5.9375C3.97571 5.84028 3.99307 5.75 4.02085 5.66667L0.187515 1.83333L1.20835 0.8125L18.2917 17.8958L17.2709 18.9167ZM13.4375 10.5208C14.2708 10.6597 15.0556 10.8194 15.7917 11C16.5278 11.1806 17.132 11.4028 17.6042 11.6667C18.0903 11.9167 18.4827 12.2847 18.7813 12.7708C19.0799 13.2569 19.2292 13.8264 19.2292 14.4792V16.0417H18.5209L15.6667 13.1875C15.5 12.6319 15.2292 12.1493 14.8542 11.7396C14.4792 11.3299 14.007 10.9236 13.4375 10.5208V10.5208ZM11.2292 8.77083C11.4931 8.39583 11.6945 7.96528 11.8333 7.47917C11.9722 6.99306 12.0417 6.46528 12.0417 5.89583C12.0417 5.25694 11.9549 4.68056 11.7813 4.16667C11.6077 3.65278 11.3403 3.18056 10.9792 2.75C11.132 2.69444 11.2952 2.65278 11.4688 2.625C11.6424 2.59722 11.8125 2.58333 11.9792 2.58333C12.9514 2.58333 13.7465 2.89236 14.3646 3.51042C14.9827 4.12847 15.2917 4.92361 15.2917 5.89583C15.2917 6.92361 14.9375 7.77083 14.2292 8.4375C13.5209 9.10417 12.6667 9.35417 11.6667 9.1875L11.2292 8.77083ZM10.1042 7.66667L5.47918 3.02083C5.71529 2.88194 5.98613 2.77431 6.29168 2.69792C6.59724 2.62153 6.91668 2.58333 7.25002 2.58333C8.22224 2.58333 9.02085 2.88889 9.64585 3.5C10.2708 4.11111 10.5833 4.90972 10.5833 5.89583C10.5833 6.22917 10.5452 6.54861 10.4688 6.85417C10.3924 7.15972 10.2708 7.43056 10.1042 7.66667V7.66667Z"
                  fill="#3171B3"
                />
              </svg>
              Unsubscribe rate
            </div>
            <div
              class="spinner-border text-primary loading-spinner"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else>{{ subscribers.unsubscribeRate }}%</div>
          </div>
        </div>

        <!-- Button-row  -->

        <div class="button-row" @click="setIndexType($event)">
          <v-btn
            text
            class="border"
            :class="indexType === 'total' ? 'active' : ''"
            :loading="loading"
          >
            <svg
              width="10"
              height="13"
              viewBox="0 0 10 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-right: 5px; margin-bottom: 3px"
            >
              <path
                d="M0.366669 12.2167V10.6L4.78334 6.49999L0.366669 2.38333V0.783325H9.13334V3.21666H4.33334L7.75 6.49999L4.33334 9.78332H9.13334V12.2167H0.366669Z"
                :fill="indexType === 'total' ? '#fff' : '#7F7F7F'"
              />
            </svg>

            <span>Total</span>
          </v-btn>

          <v-btn
            text
            class="border"
            :loading="loading"
            :class="indexType === 'welcome drip' ? 'active' : ''"
          >
            <svg
              width="12"
              height="15"
              viewBox="0 0 12 15"
              fill="#7F7F7F"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-right: 5px; margin-bottom: 2px"
            >
              <path
                d="M6.26667 11.9666C6.46667 11.9666 6.63334 11.9194 6.76667 11.825C6.9 11.7305 6.96667 11.6166 6.96667 11.4833C6.96667 11.3278 6.90834 11.2055 6.79167 11.1166C6.675 11.0278 6.49445 10.9833 6.25 10.9833C5.72778 10.9833 5.27778 10.8389 4.9 10.55C4.52223 10.2611 4.27223 9.81109 4.15 9.19998C4.12778 9.09998 4.075 9.00275 3.99167 8.90831C3.90834 8.81386 3.79445 8.76664 3.65 8.76664C3.46111 8.76664 3.32778 8.8222 3.25 8.93331C3.17223 9.04442 3.14445 9.1722 3.16667 9.31664C3.33334 10.2611 3.72778 10.9389 4.35 11.35C4.97223 11.7611 5.61111 11.9666 6.26667 11.9666ZM6.25 14.5166C4.61667 14.5166 3.25834 13.9611 2.175 12.85C1.09167 11.7389 0.550003 10.3555 0.550003 8.69998C0.550003 7.53331 1.01945 6.26109 1.95834 4.88331C2.89723 3.50553 4.32778 1.99442 6.25 0.349976C8.17223 1.99442 9.60556 3.50553 10.55 4.88331C11.4944 6.26109 11.9667 7.53331 11.9667 8.69998C11.9667 10.3555 11.4222 11.7389 10.3333 12.85C9.24445 13.9611 7.88334 14.5166 6.25 14.5166Z"
                :fill="indexType === 'welcome drip' ? '#fff' : '#7F7F7F'"
              />
            </svg>

            <span>Welcome Drip</span>
          </v-btn>
          <v-btn
            text
            class="border"
            :loading="loading"
            :class="indexType === 'recurring' ? 'active' : ''"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-right: 5px; margin-bottom: 2px"
            >
              <path
                d="M6.68333 14.4166C5.78333 14.3055 4.96389 14.0666 4.225 13.7C3.48611 13.3333 2.83611 12.85 2.275 12.25C1.71389 11.65 1.27778 10.9472 0.966667 10.1416C0.655556 9.33609 0.5 8.45554 0.5 7.49998C0.5 6.58887 0.697222 5.71387 1.09167 4.87498C1.48611 4.03609 2.02222 3.2722 2.7 2.58331H0.716667V1.06665H5.35V5.69998H3.83333V3.63331C3.24444 4.17776 2.79444 4.77776 2.48333 5.43331C2.17222 6.08887 2.01667 6.77776 2.01667 7.49998C2.01667 8.89998 2.46111 10.0972 3.35 11.0916C4.23889 12.0861 5.35 12.6833 6.68333 12.8833V14.4166ZM6.3 10.5666L3.56667 7.83331L4.5 6.88331L6.3 8.68331L9.98333 4.99998L10.9333 5.94998L6.3 10.5666ZM9.16667 13.9166V9.29998H10.6833V11.35C11.2611 10.8055 11.7083 10.2083 12.025 9.55831C12.3417 8.90831 12.5 8.2222 12.5 7.49998C12.5 6.09998 12.0528 4.90276 11.1583 3.90831C10.2639 2.91387 9.15556 2.31109 7.83333 2.09998V0.583313C9.57778 0.783313 11.0444 1.52776 12.2333 2.81665C13.4222 4.10554 14.0167 5.66665 14.0167 7.49998C14.0167 8.41109 13.8167 9.28609 13.4167 10.125C13.0167 10.9639 12.4833 11.7222 11.8167 12.4H13.7833V13.9166H9.16667Z"
                :fill="indexType === 'recurring' ? '#fff' : '#7F7F7F'"
              />
            </svg>

            <span>Recurring</span>
          </v-btn>
          <v-btn
            text
            class="border"
            :loading="loading"
            :class="indexType === 'dead list' ? 'active' : ''"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-right: 5px"
            >
              <path
                d="M14.8333 15.0833L11.6667 11.9166H1.66666V1.91665L0.916664 1.18331L1.76666 0.333313L15.6833 14.2333L14.8333 15.0833ZM15.85 12.7166L11.95 8.83331H12.75V7.83331H10.95L9.78333 6.66665H12.75V5.66665H8.78333L7.61666 4.49998H12.75V3.49998H6.61666L3.53333 0.39998H15.85V12.7166ZM4.75 8.83331H8.58333L7.58333 7.83331H4.75V8.83331ZM4.75 6.66665H6.41666L5.41666 5.66665H4.75V6.66665Z"
                :fill="indexType === 'dead list' ? '#fff' : '#7F7F7F'"
              />
            </svg>

            <span>Dead list</span>
          </v-btn>
        </div>

        <!-- Msg-card-row -->
        <div class="msg-card-row">
          <div class="msg-card">
            <span class="icon-mail d-flex justify-center align-items-center">
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.145844 15.1875V0.791687H17.875V15.1875H0.145844ZM9.00001 9.04169L15.8958 4.39585V2.77085L9.00001 7.31252L2.10418 2.77085V4.39585L9.00001 9.04169Z"
                  fill="white"
                />
              </svg>
            </span>
            <div class="title">Sent</div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-if="!loading">
              {{ formatNumber(getIndexTypeValue("sent")) }}
            </div>
            <!-- <div class="info-status bad">
              <i class="mdi mdi-arrow-bottom-left-thick"></i>
              <Spinner v-if="loading" class="spinner-loading--sm ml-1" />
              <span class="value" v-else>2%</span>
              errors or crashes
            </div> -->
          </div>

          <div class="msg-card">
            <span class="icon-mail d-flex justify-center align-items-center">
              <svg
                width="19"
                height="17"
                viewBox="0 0 19 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 5.81248C14.7639 5.81248 14.1389 5.55554 13.625 5.04165C13.1111 4.52776 12.8542 3.90276 12.8542 3.16665C12.8542 2.43054 13.1111 1.80554 13.625 1.29165C14.1389 0.777757 14.7639 0.520813 15.5 0.520813C16.2361 0.520813 16.8611 0.777757 17.375 1.29165C17.8889 1.80554 18.1458 2.43054 18.1458 3.16665C18.1458 3.90276 17.8889 4.52776 17.375 5.04165C16.8611 5.55554 16.2361 5.81248 15.5 5.81248ZM0.812508 16.1875V1.79165H11.4167C11.2917 2.12498 11.2153 2.45484 11.1875 2.78123C11.1597 3.10762 11.1736 3.43748 11.2292 3.77081C11.2986 4.2847 11.4514 4.7604 11.6875 5.1979C11.9236 5.6354 12.2292 6.01387 12.6042 6.33331L9.66667 8.31248L2.77084 3.70831V5.39581L9.66667 10.0416L13.9583 7.14581C14.1945 7.25692 14.441 7.34026 14.6979 7.39581C14.9549 7.45137 15.2222 7.47915 15.5 7.47915C16.0833 7.47915 16.632 7.37498 17.1458 7.16665C17.6597 6.95831 18.125 6.65276 18.5417 6.24998V16.1875H0.812508Z"
                  fill="white"
                />
              </svg>
            </span>
            <div class="title">Delivered</div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-if="!loading">
              {{ formatNumber(getIndexTypeValue("delivered")) }}
            </div>
            <div
              class="info-status"
              :class="[
                Math.sign(getIndexTypeValue('ctr')) === 1 ? 'good' : 'bad',
              ]"
            >
              <i
                class="mdi"
                :class="[
                  Math.sign(getIndexTypeValue('ctr')) === 1
                    ? 'mdi-arrow-top-right-thick'
                    : 'mdi-arrow-bottom-left-thick',
                ]"
              ></i>
              <Spinner v-if="loading" class="spinner-loading--sm ml-1" />
              <div class="value" v-if="!loading">
                {{ getIndexTypeValue("deliveryRate", true) }}%
              </div>
              delivery rate
            </div>
          </div>

          <div class="msg-card">
            <span class="icon-mail d-flex justify-center align-items-center">
              <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.20835 15.7083C7.6389 15.6805 6.31598 15.1146 5.2396 14.0104C4.16321 12.9062 3.62501 11.5694 3.62501 9.99998C3.62501 8.40276 4.1771 7.04859 5.28126 5.93748C6.38543 4.82637 7.73612 4.27081 9.33335 4.27081C10.9028 4.27081 12.2396 4.81595 13.3438 5.90623C14.4479 6.99651 15.0208 8.33331 15.0625 9.91665L13.25 9.35415C13.1111 8.39581 12.6736 7.60067 11.9375 6.96873C11.2014 6.33679 10.3333 6.02081 9.33335 6.02081C8.22223 6.02081 7.28126 6.40623 6.51043 7.17706C5.7396 7.9479 5.35418 8.88887 5.35418 9.99998C5.35418 11 5.67015 11.8646 6.3021 12.5937C6.93404 13.3229 7.72223 13.7639 8.66668 13.9166L9.20835 15.7083ZM10.2708 19.25C10.1181 19.2639 9.96529 19.2743 9.81251 19.2812C9.65973 19.2882 9.50001 19.2916 9.33335 19.2916C8.05557 19.2916 6.85071 19.0486 5.71876 18.5625C4.58682 18.0764 3.60071 17.4132 2.76043 16.5729C1.92015 15.7326 1.25696 14.7465 0.770846 13.6146C0.284735 12.4826 0.0416794 11.2778 0.0416794 9.99998C0.0416794 8.7222 0.284735 7.51734 0.770846 6.3854C1.25696 5.25345 1.92015 4.26734 2.76043 3.42706C3.60071 2.58679 4.58682 1.92359 5.71876 1.43748C6.85071 0.951369 8.05557 0.708313 9.33335 0.708313C10.6111 0.708313 11.816 0.951369 12.9479 1.43748C14.0799 1.92359 15.066 2.58679 15.9063 3.42706C16.7465 4.26734 17.4097 5.25345 17.8958 6.3854C18.382 7.51734 18.625 8.7222 18.625 9.99998C18.625 10.1666 18.6215 10.3298 18.6146 10.4896C18.6077 10.6493 18.5972 10.8055 18.5833 10.9583L16.8958 10.4583V9.99998C16.8958 7.90276 16.1597 6.11803 14.6875 4.64581C13.2153 3.17359 11.4306 2.43748 9.33335 2.43748C7.23612 2.43748 5.4514 3.17359 3.97918 4.64581C2.50696 6.11803 1.77085 7.90276 1.77085 9.99998C1.77085 12.0972 2.50696 13.8819 3.97918 15.3541C5.4514 16.8264 7.23612 17.5625 9.33335 17.5625H9.77085L10.2708 19.25ZM16.6667 19.2291L13 15.5416L11.9375 18.7291L9.33335 9.99998L18.0625 12.6041L14.875 13.6666L18.5625 17.3333L16.6667 19.2291Z"
                  fill="white"
                />
              </svg>
            </span>
            <div class="title">Clicked</div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-if="!loading">
              {{ formatNumber(getIndexTypeValue("clicked")) }}
            </div>
            <div
              class="info-status"
              :class="[
                Math.sign(getIndexTypeValue('ctr')) === 1 ? 'good' : 'bad',
              ]"
            >
              <i
                class="mdi"
                :class="[
                  Math.sign(getIndexTypeValue('ctr')) === 1
                    ? 'mdi-arrow-top-right-thick'
                    : 'mdi-arrow-bottom-left-thick',
                ]"
              ></i>
              <Spinner v-if="loading" class="spinner-loading--sm ml-1" />
              <div class="value" v-if="!loading">
                {{ getIndexTypeValue("ctr", true) }}%
              </div>
              CTR
            </div>
          </div>
        </div>

        <!-- Info-card-row -->
        <div class="info-card-row">
          <div
            class="info-card i1 d-flex justify-space-between align-items-center"
          >
            <span class="icon-help">
              <i class="mdi mdi-help"></i>
            </span>
            <div class="help-info">
              <div class="title">Lorem Ipsum is simply</div>
              <p>
                It is a long established fact thata reader will be distracted by
                the readable content
              </p>
            </div>
            <div class="text">
              <div class="title">Conversion Rate</div>
              <p>Ratio of conversion to sent pushes</p>
            </div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else-if="!loading">0%</div>
          </div>

          <div
            class="info-card i2 d-flex justify-space-between align-items-center"
          >
            <span class="icon-help">
              <i class="mdi mdi-help"></i>
            </span>
            <div class="help-info">
              <div class="title">Lorem Ipsum is simply</div>
              <p>
                It is a long established fact thata reader will be distracted by
                the readable content
              </p>
            </div>
            <div class="text">
              <div class="title">Subscribe Rate</div>
              <p>Ratio of subscribes to total subscribe attempts</p>
            </div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else-if="!loading">0%</div>
          </div>

          <div
            class="info-card i3 d-flex justify-space-between align-items-center"
          >
            <span class="icon-help">
              <i class="mdi mdi-help"></i>
            </span>
            <div class="help-info">
              <div class="title">Lorem Ipsum is simply</div>
              <p>
                It is a long established fact thata reader will be distracted by
                the readable content
              </p>
            </div>
            <div class="text">
              <div class="title">Clicks per subscriber</div>
              <p>Average number of clicks per subscriber</p>
            </div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else-if="!loading">
              {{ getIndexTypeValue("clicksPerSubscriber") }}
            </div>
          </div>

          <div
            class="info-card i4 d-flex justify-space-between align-items-center"
          >
            <span class="icon-help">
              <i class="mdi mdi-help"></i>
            </span>
            <div class="help-info">
              <div class="title">Lorem Ipsum is simply</div>
              <p>
                It is a long established fact thata reader will be distracted by
                the readable content
              </p>
            </div>
            <div class="text">
              <div class="title">Subscriber LTV</div>
              <p>Average spent by each subscriber during subs</p>
            </div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else-if="!loading">0$</div>
          </div>

          <div
            class="info-card i5 d-flex justify-space-between align-items-center"
          >
            <span class="icon-help">
              <i class="mdi mdi-help"></i>
            </span>
            <div class="help-info">
              <div class="title">Lorem Ipsum is simply</div>
              <p>
                It is a long established fact thata reader will be distracted by
                the readable content
              </p>
            </div>
            <div class="text">
              <div class="title">Average revenue per subscriber</div>
            </div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else-if="!loading">
              {{ getIndexTypeValue("revenuePerSubscriber") }}$
            </div>
          </div>

          <div
            class="info-card i6 d-flex justify-space-between align-items-center"
          >
            <span class="icon-help">
              <i class="mdi mdi-help"></i>
            </span>
            <div class="help-info">
              <div class="title">Lorem Ipsum is simply</div>
              <p>
                It is a long established fact thata reader will be distracted by
                the readable content
              </p>
            </div>
            <div class="text">
              <div class="title">Average revenue per push</div>
            </div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else-if="!loading">
              {{ getIndexTypeValue("revenuePerPush") }}$
            </div>
          </div>

          <div
            class="info-card i7 d-flex justify-space-between align-items-center"
          >
            <span class="icon-help">
              <i class="mdi mdi-help"></i>
            </span>
            <div class="help-info">
              <div class="title">Lorem Ipsum is simply</div>
              <p>
                It is a long established fact thata reader will be distracted by
                the readable content
              </p>
            </div>
            <div class="text">
              <div class="title">Hate Rate</div>
              <p>Share of unsubscribed after receiving a push</p>
            </div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-cloak v-else-if="!loading">
              {{ getIndexTypeValue("hateRate") }}%
            </div>
          </div>

          <div
            class="info-card i8 d-flex justify-space-between align-items-center"
          >
            <span class="icon-help">
              <i class="mdi mdi-help"></i>
            </span>
            <div class="help-info">
              <div class="title">Lorem Ipsum is simply</div>
              <p>
                It is a long established fact thata reader will be distracted by
                the readable content
              </p>
            </div>
            <div class="text">
              <div class="title">Patience days</div>
              <p>Average number of days before unsubscribing</p>
            </div>
            <div
              class="spinner-border text-primary loading-spinner mb-4"
              role="status"
              v-if="loading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <div class="value" v-else-if="!loading">
              {{ subscribers.patienceDays }}
            </div>
            <a href="#" class="link-more-info">More info</a>
          </div>
        </div>
      </div>

      <!-- Right content -->
      <div class="mi-right">
        <div
          class="w-100 overflow-hidden position-relative best-content"
          style="
            min-height: 88px;
            border: 3px solid #dfe1e5;
            border-radius: 4px;
            padding-top: 25px;
            background-color: #f8fafb;
            margin-bottom: 34px;
          "
        >
          <div
            class="w-100 position-absolute d-flex justify-content-between preview-header align-items-center"
            style="
              top: 0;
              right: 0;
              height: 25px !important;
              background: #dad9d9 !important;
            "
          >
            <div class="d-flex justify-content-start">
              <div class="overflow-hidden" style="margin-bottom: 2px">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin: 0 2px 0 4px"
                >
                  <g filter="url(#filter0_i_172_618)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.724 6.7945C5.41989 6.7945 6.79468 5.41971 6.79468 3.72382C6.79468 2.02793 5.41989 0.653137 3.724 0.653137C2.02811 0.653137 0.65332 2.02793 0.65332 3.72382C0.65332 5.41971 2.02811 6.7945 3.724 6.7945Z"
                      fill="#ED6A5E"
                    />
                  </g>
                  <path
                    d="M6.66674 3.72382C6.66674 5.34905 5.34923 6.66655 3.724 6.66655C2.09877 6.66655 0.781265 5.34905 0.781265 3.72382C0.781265 2.09859 2.09877 0.781082 3.724 0.781082C5.34923 0.781082 6.66674 2.09859 6.66674 3.72382Z"
                    stroke="#CE5347"
                    stroke-width="0.25589"
                  />
                  <defs>
                    <filter
                      id="filter0_i_172_618"
                      x="0.65332"
                      y="0.653137"
                      width="6.1416"
                      height="6.14136"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation="1.53534" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_172_618"
                      />
                    </filter>
                  </defs>
                </svg>
                <svg
                  width="8"
                  height="7"
                  viewBox="0 0 8 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-right: 2px"
                >
                  <g filter="url(#filter0_i_172_619)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.95935 6.7945C5.65524 6.7945 7.03003 5.41971 7.03003 3.72382C7.03003 2.02793 5.65524 0.653137 3.95935 0.653137C2.26346 0.653137 0.888672 2.02793 0.888672 3.72382C0.888672 5.41971 2.26346 6.7945 3.95935 6.7945Z"
                      fill="#F6BE4F"
                    />
                  </g>
                  <path
                    d="M6.90209 3.72382C6.90209 5.34905 5.58458 6.66655 3.95935 6.66655C2.33412 6.66655 1.01662 5.34905 1.01662 3.72382C1.01662 2.09859 2.33412 0.781082 3.95935 0.781082C5.58458 0.781082 6.90209 2.09859 6.90209 3.72382Z"
                    stroke="#D6A243"
                    stroke-width="0.25589"
                  />
                  <defs>
                    <filter
                      id="filter0_i_172_619"
                      x="0.888672"
                      y="0.653137"
                      width="6.1416"
                      height="6.14136"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation="1.53534" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_172_619"
                      />
                    </filter>
                  </defs>
                </svg>
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-right: 2px"
                >
                  <g filter="url(#filter0_i_172_620)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.19568 6.7945C4.89157 6.7945 6.26636 5.41971 6.26636 3.72382C6.26636 2.02793 4.89157 0.653137 3.19568 0.653137C1.49979 0.653137 0.125 2.02793 0.125 3.72382C0.125 5.41971 1.49979 6.7945 3.19568 6.7945Z"
                      fill="#62C554"
                    />
                  </g>
                  <path
                    d="M6.13842 3.72382C6.13842 5.34905 4.82091 6.66655 3.19568 6.66655C1.57045 6.66655 0.252945 5.34905 0.252945 3.72382C0.252945 2.09859 1.57045 0.781082 3.19568 0.781082C4.82091 0.781082 6.13842 2.09859 6.13842 3.72382Z"
                    stroke="#58A942"
                    stroke-width="0.25589"
                  />
                  <defs>
                    <filter
                      id="filter0_i_172_620"
                      x="0.125"
                      y="0.653137"
                      width="6.1416"
                      height="6.14136"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation="1.53534" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_172_620"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div style="margin-left: 3px">
                <span style="height: 15px !important">
                  <svg
                    width="4"
                    height="7"
                    viewBox="0 0 4 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.56902 6.36268L1.05448 3.84813C1.03814 3.83181 1.02517 3.81244 1.01633 3.7911C1.00748 3.76977 1.00293 3.7469 1.00293 3.72381C1.00293 3.70072 1.00748 3.67785 1.01633 3.65652C1.02517 3.63519 1.03814 3.61581 1.05448 3.59949L3.56902 1.08495"
                      stroke="#575757"
                      stroke-width="0.76767"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    width="5"
                    height="7"
                    viewBox="0 0 5 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.30988 6.36268L3.82443 3.84813C3.84077 3.83181 3.85373 3.81244 3.86258 3.7911C3.87142 3.76977 3.87598 3.7469 3.87598 3.72381C3.87598 3.70072 3.87142 3.67785 3.86258 3.65652C3.85373 3.63519 3.84077 3.61581 3.82443 3.59949L1.30988 1.08495"
                      stroke="#ADADAD"
                      stroke-width="0.76767"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
              <div>
                <span>
                  <svg
                    width="9"
                    height="7"
                    viewBox="0 0 9 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.9325 0.653137C8.21515 0.653137 8.44428 0.882269 8.44428 1.16492V6.28272C8.44428 6.56537 8.21515 6.7945 7.9325 6.7945H1.27936C0.99671 6.7945 0.767578 6.56537 0.767578 6.28272V1.16492C0.767578 0.882269 0.99671 0.653137 1.27936 0.653137H7.9325ZM3.83826 1.16492H7.9325V6.28272H3.83826V1.16492ZM3.32648 6.28272H1.27936L1.27936 1.16492H3.32648V6.28272Z"
                      fill="#585758"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div class="preview-header--search-input">
              <span>
                <svg
                  width="5"
                  height="6"
                  viewBox="0 0 5 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.16412 2.83835H0.652344V5.90903H4.74658V2.83835H4.2348V2.32657C4.2348 1.47862 3.54741 0.791229 2.69946 0.791229C1.85152 0.791229 1.16412 1.47862 1.16412 2.32657V2.83835ZM1.6759 2.83835H3.72302V2.32657C3.72302 1.76127 3.26476 1.30301 2.69946 1.30301C2.13417 1.30301 1.6759 1.76127 1.6759 2.32657V2.83835Z"
                    fill="#A09FA0"
                  />
                </svg>
              </span>
              <span style="font-size: 5px">{{
                getDomainUrl($route.params.id)
              }}</span>
              <span>
                <svg
                  width="7"
                  height="8"
                  viewBox="0 0 7 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.33722 3.35962L5.64023 1.91917L3.33722 0.478729V1.5468C1.90259 1.67609 0.77832 2.88182 0.77832 4.35013C0.77832 5.90468 2.03853 7.16492 3.59311 7.16492C5.14769 7.16492 6.4079 5.90468 6.4079 4.35013V4.09424H5.89612V4.35013C5.89612 5.62205 4.86506 6.65314 3.59311 6.65314C2.32116 6.65314 1.2901 5.62205 1.2901 4.35013C1.2901 3.1647 2.18572 2.18846 3.33722 2.06117V3.35962Z"
                    fill="#7B7C7C"
                  />
                </svg>
              </span>
            </div>
            <div class="d-flex">
              <div>
                <svg
                  width="7"
                  height="9"
                  viewBox="0 0 7 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.69328 2.58193C4.78225 2.69172 4.94343 2.70859 5.05313 2.61963C5.16296 2.53064 5.17982 2.36952 5.09086 2.25969L3.87176 0.755336C3.85652 0.7365 3.83903 0.718821 3.81928 0.702921C3.80192 0.688958 3.78267 0.67637 3.76181 0.665687C3.73282 0.650819 3.70133 0.640136 3.66835 0.634388C3.65011 0.631233 3.63149 0.629578 3.61262 0.629578C3.5594 0.629578 3.50842 0.642635 3.46344 0.665687C3.41871 0.688521 3.38197 0.720008 3.35336 0.755336L2.13438 2.25969C2.04542 2.36949 2.06229 2.53064 2.17212 2.61963C2.28182 2.70859 2.443 2.69172 2.53196 2.58193L3.35673 1.56414V5.74738H3.86851V1.56414L4.69328 2.58193Z"
                    fill="#575757"
                  />
                  <path
                    d="M3.86853 3.18848H3.35675V3.70026H3.86853V3.18848Z"
                    fill="#575757"
                  />
                  <path
                    d="M4.38031 3.70026H5.91565V7.7945H1.30963V3.70026H2.84497V3.18848H1.30963C1.027 3.18848 0.797852 3.4176 0.797852 3.70026V7.7945C0.797852 8.07716 1.027 8.30628 1.30963 8.30628H5.91565C6.19828 8.30628 6.42743 8.07716 6.42743 7.7945V3.70026C6.42743 3.4176 6.19828 3.18848 5.91565 3.18848H4.38031V3.70026Z"
                    fill="#575757"
                  />
                </svg>
              </div>
              <div>
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.20282 1.16492H2.62036V1.6767H2.10858V1.16492C2.10858 0.882258 2.33773 0.653137 2.62036 0.653137H6.20282C6.48545 0.653137 6.7146 0.882258 6.7146 1.16492V4.74738C6.7146 5.03004 6.48545 5.25916 6.20282 5.25916H5.69104V4.74738H6.20282V1.16492Z"
                    fill="#575757"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.573242 2.70026C0.573242 2.4176 0.802394 2.18848 1.08502 2.18848H4.66748C4.95011 2.18848 5.17926 2.4176 5.17926 2.70026V6.28272C5.17926 6.56538 4.95011 6.7945 4.66748 6.7945H1.08502C0.802394 6.7945 0.573242 6.56538 0.573242 6.28272V2.70026ZM1.08502 2.70026H4.66748V6.28272H1.08502V2.70026Z"
                    fill="#575757"
                  />
                </svg>
              </div>
              <div>
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.85974 0.723816H3.34796V3.28272H0.789062V3.7945H3.34796V6.3534H3.85974V3.7945H6.41864V3.28272H3.85974V0.723816Z"
                    fill="#646565"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-start">
            <em></em>
          </div>

          <div class="push-card">
            <div class="title">Best welcome drip push:</div>
            <div class="message-content d-flex">
              <div class="pic">
                <img v-if="theBestWelcome.icon" :src="theBestWelcome.icon" />
              </div>
              <div class="message">
                <div class="title">{{ theBestWelcome.title || "Title" }}</div>
                <div class="text">{{ theBestWelcome.body || "Message" }}</div>
                <div class="url">
                  {{ getDomainUrl($route.params.id) }}
                </div>
              </div>
            </div>
            <div
              class="push-info d-flex justify-space-between align-items-center"
            >
              <div class="ctr d-flex align-items-center">
                <span
                  class="icon-mail d-flex justify-center align-items-center"
                >
                  <svg
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.8333 5.81248C14.0972 5.81248 13.4722 5.55554 12.9583 5.04165C12.4445 4.52776 12.1875 3.90276 12.1875 3.16665C12.1875 2.43054 12.4445 1.80554 12.9583 1.29165C13.4722 0.777757 14.0972 0.520813 14.8333 0.520813C15.5695 0.520813 16.1945 0.777757 16.7083 1.29165C17.2222 1.80554 17.4792 2.43054 17.4792 3.16665C17.4792 3.90276 17.2222 4.52776 16.7083 5.04165C16.1945 5.55554 15.5695 5.81248 14.8333 5.81248ZM0.145844 16.1875V1.79165H10.75C10.625 2.12498 10.5486 2.45484 10.5208 2.78123C10.4931 3.10762 10.507 3.43748 10.5625 3.77081C10.632 4.2847 10.7847 4.7604 11.0208 5.1979C11.257 5.6354 11.5625 6.01387 11.9375 6.33331L9.00001 8.31248L2.10418 3.70831V5.39581L9.00001 10.0416L13.2917 7.14581C13.5278 7.25692 13.7743 7.34026 14.0313 7.39581C14.2882 7.45137 14.5556 7.47915 14.8333 7.47915C15.4167 7.47915 15.9653 7.37498 16.4792 7.16665C16.9931 6.95831 17.4583 6.65276 17.875 6.24998V16.1875H0.145844Z"
                      fill="#3171B3"
                    />
                  </svg>
                </span>
                <div>
                  <div class="title">CTR</div>
                  <div class="text">Efficiency</div>
                </div>
              </div>
              <div class="value">
                {{
                  (theBestWelcome.push_ctr
                    ? parseFloat(theBestWelcome.push_ctr).toFixed(2)
                    : "0") + "%"
                }}
              </div>
            </div>
            <p>Action button</p>
            <div
              class="btn-group d-flex justify-space-between align-items-center"
            >
              <v-btn
                v-if="
                  theBestWelcome.customization &&
                    theBestWelcome.customization.button1 !== undefined
                "
                >{{ theBestWelcome.customization.button1.title }}</v-btn
              >
              <v-btn
                v-if="
                  theBestWelcome.customization &&
                    theBestWelcome.customization.button2 !== undefined
                "
                >{{ theBestWelcome.customization.button2.title }}</v-btn
              >
            </div>
          </div>

          <v-divider></v-divider>

          <div class="push-card">
            <div class="title">Best reccuring push:</div>
            <div class="message-content d-flex">
              <div class="pic">
                <img
                  v-if="theBestRecurring.icon"
                  :src="theBestRecurring.icon"
                />
              </div>
              <div class="message">
                <div class="title">{{ theBestRecurring.title || "Title" }}</div>
                <div class="text">{{ theBestRecurring.body || "Message" }}</div>
                <div class="url">
                  {{ getDomainUrl($route.params.id) }}
                </div>
              </div>
            </div>
            <div
              class="push-info d-flex justify-space-between align-items-center"
            >
              <div class="ctr d-flex align-items-center">
                <span
                  class="icon-mail d-flex justify-center align-items-center"
                >
                  <svg
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.8333 5.81248C14.0972 5.81248 13.4722 5.55554 12.9583 5.04165C12.4445 4.52776 12.1875 3.90276 12.1875 3.16665C12.1875 2.43054 12.4445 1.80554 12.9583 1.29165C13.4722 0.777757 14.0972 0.520813 14.8333 0.520813C15.5695 0.520813 16.1945 0.777757 16.7083 1.29165C17.2222 1.80554 17.4792 2.43054 17.4792 3.16665C17.4792 3.90276 17.2222 4.52776 16.7083 5.04165C16.1945 5.55554 15.5695 5.81248 14.8333 5.81248ZM0.145844 16.1875V1.79165H10.75C10.625 2.12498 10.5486 2.45484 10.5208 2.78123C10.4931 3.10762 10.507 3.43748 10.5625 3.77081C10.632 4.2847 10.7847 4.7604 11.0208 5.1979C11.257 5.6354 11.5625 6.01387 11.9375 6.33331L9.00001 8.31248L2.10418 3.70831V5.39581L9.00001 10.0416L13.2917 7.14581C13.5278 7.25692 13.7743 7.34026 14.0313 7.39581C14.2882 7.45137 14.5556 7.47915 14.8333 7.47915C15.4167 7.47915 15.9653 7.37498 16.4792 7.16665C16.9931 6.95831 17.4583 6.65276 17.875 6.24998V16.1875H0.145844Z"
                      fill="#3171B3"
                    />
                  </svg>
                </span>
                <div>
                  <div class="title">CTR</div>
                  <div class="text">Efficiency</div>
                </div>
              </div>
              <div class="value">
                {{
                  (theBestRecurring.push_ctr
                    ? parseFloat(theBestRecurring.push_ctr).toFixed(2)
                    : "0") + "%"
                }}
              </div>
            </div>
            <p>Action button</p>
            <div
              class="btn-group d-flex justify-space-between align-items-center"
            >
              <v-btn
                v-if="
                  theBestRecurring.customization &&
                    theBestRecurring.customization.button1 !== undefined
                "
                >{{ theBestRecurring.customization.button1.title }}</v-btn
              >
              <v-btn
                v-if="
                  theBestRecurring.customization &&
                    theBestRecurring.customization.button2 !== undefined
                "
                >{{ theBestRecurring.customization.button2.title }}</v-btn
              >
            </div>
          </div>
        </div>
        <!-- <v-btn block outlined color="grey" class="btn-pushes"
          >See pushes CTR</v-btn
        > -->
      </div>
    </div>

    <Error v-if="error" :error="error" />
  </div>
</template>

<script>
import AsideBar from "./AsideBar.vue";
// import User from "../../apis/User";
import statistics from "../../mixins/statistics";
import DatePicker from "vue2-datepicker";
import Error from "../popUps/Error.vue";
import Warnings from "../popUps/Warnings.vue";
import Spinner from "../popUps/Spinner.vue";
import "vue2-datepicker/index.css";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import Statistics from "../../apis/Statistics";
import Drip from "../../apis/Drip";

export default {
  components: {
    AsideBar,
    DatePicker,
    Error,
    Warnings,
    Spinner,
  },
  mixins: [statistics],
  name: "MoreInfo",
  data: () => ({
    indexType: "welcome drip",
    datePicker: [
      new Date(
        moment()
          .subtract(1, "days")
          .format("YYYY, MM, DD")
      ),
      new Date(moment().format("YYYY, MM, DD")),
    ],

    theBestWelcome: {},
    theBestRecurring: {},

    subscribers: {
      subs: 0,
      unsubs: 0,
      unsubscribeRate: 0,
      patienceDays: 0,
    },
    total: {
      revenuePerSubscriber: 0,
      revenuePerPush: 0,
      subscriberLtv: 0,
      clicksPerSubscriber: 0,
      sent: 0,
      delivered: 0,
      clicked: 0,
      deliveryRate: 0,
      ctr: 0,
      hateRate: 0,
    },
    welcome: {
      revenuePerSubscriber: 0,
      revenuePerPush: 0,
      subscriberLtv: 0,
      clicksPerSubscriber: 0,
      sent: 0,
      delivered: 0,
      clicked: 0,
      deliveryRate: 0,
      ctr: 0,
      hateRate: 0,
    },
    recurring: {
      revenuePerSubscriber: 0,
      revenuePerPush: 0,
      subscriberLtv: 0,
      clicksPerSubscriber: 0,
      sent: 0,
      delivered: 0,
      clicked: 0,
      deliveryRate: 0,
      ctr: 0,
      hateRate: 0,
    },
    deadList: {
      revenuePerSubscriber: 0,
      revenuePerPush: 0,
      subscriberLtv: 0,
      clicksPerSubscriber: 0,
      sent: 0,
      delivered: 0,
      clicked: 0,
      deliveryRate: 0,
      ctr: 0,
      hateRate: 0,
    },
  }),
  computed: {
    ...mapGetters(["getDomainUrl"]),
  },
  mounted() {
    this.getStatsData();
  },
  methods: {
    ...mapActions(["logout"]),
    getStatsData() {
      this.loading = true;

      for (let type of ["recurring", "welcome", ""]) {
        this.getDripStatistics(
          this.datePicker[0],
          this.datePicker[1],
          this.$route.params.id,
          type,
          this.dateRange
        );

        if (type) {
          this.getTheBestDrip(
            type,
            moment(this.datePicker[0]).format("YYYY-MM-DD"),
            moment(this.datePicker[1]).format("YYYY-MM-DD"),
            this.dateRange,
            this.$route.params.id
          );
        }
      }

      this.getSubStatistics(
        this.datePicker[0],
        this.datePicker[1],
        this.$route.params.id,
        this.dateRange
      );
    },

    getDripStatistics(
      dateStart,
      dateEnd,
      domainId,
      type = "",
      dateRange = "day"
    ) {
      let typeParams = type ? `&drip_type=${type}` : "";

      Statistics.getStatsEventsByDrips(
        `date_start=${moment(dateStart).format(
          "YYYY-MM-DD"
        )}&date_finish=${moment(dateEnd).format(
          "YYYY-MM-DD"
        )}&date_trunc=millennium&domain_ids=${domainId}` + typeParams
      )
        .then((response) => {
          // Sends
          this[type || "total"]["sent"] = response.data.data[0]["sent"];
          // Clicks
          this[type || "total"]["clicked"] = response.data.data[0]["clicked"];
          // CTR
          this[type || "total"]["ctr"] = parseFloat(
            response.data.data[0]["push_ctr"] || 0
          ).toFixed(2);
          // Delivery Rate
          this[type || "total"]["deliveryRate"] = parseFloat(
            response.data.data[0]["delivery_rate"] || 0
          ).toFixed(2);
          // Deliveries
          this[type || "total"]["delivered"] =
            response.data.data[0]["delivered"];
          // Hate Rate
          this[type || "total"]["hateRate"] = parseFloat(
            response.data.data[0]["hate_rate"] || 0
          ).toFixed(2);
          // Clicks Per Subscriber
          this[type || "total"]["clicksPerSubscriber"] = parseFloat(
            response.data.data[0]["clicks_per_subscriber"] || 0
          ).toFixed(2);
          // Subscriber Ltv
          this[type || "total"]["subscriberLtv"] = parseFloat(
            response.data.data[0]["subscriber_ltv"] || 0
          ).toFixed(2);
          // Revenue Per Subscriber
          this[type || "total"]["revenuePerPush"] = parseFloat(
            response.data.data[0]["revenue_per_push"] || 0
          ).toFixed(2);
          // Revenue Per Push
          this[type || "total"]["revenuePerSubscriber"] = parseFloat(
            response.data.data[0]["revenue_per_subscriber"] || 0
          ).toFixed(2);
        })
        .then(() => {
          Statistics.getStatsEventsByDrips(
            `date_start=${moment(dateStart)
              .subtract(1, dateRange + "s")
              .format("YYYY-MM-DD")}&date_finish=${moment(dateEnd).format(
              "YYYY-MM-DD"
            )}&date_trunc=millennium&domain_ids=${domainId}` + typeParams
          ).then((response) => {
            for (let type of ["recurring", "welcome", ""]) {
              this[type || "total"]["ctr"] -= parseFloat(
                response.data.data[0]["push_ctr"] || 0
              ).toFixed(2);

              this[type || "total"]["deliveryRate"] -= parseFloat(
                response.data.data[0]["delivery_rate"] || 0
              ).toFixed(2);
            }
          });
        })
        .catch((err) => {
          if (err.response.status === 419 || err.response.status === 401) {
            this.logout().then(() => {
              localStorage.removeItem("auth");
              //localStorage.removeItem("login");
              this.$route.replace({
                name: "Login",
                path: this.$route.path,
              });
            });
          } else {
            this.error = err;
          }
        });
    },
    getSubStatistics(dateStart, dateEnd, domainId, dateRange = "day") {
      Statistics.getStatsBySubscribables(
        `date_start=${moment(dateStart).format(
          "YYYY-MM-DD"
        )}&date_finish=${moment(dateEnd).format(
          "YYYY-MM-DD"
        )}&domain_ids=${domainId}&date_trunc=millennium`
      )
        .then((response) => {
          // Subs
          this.subscribers.subs = response.data.data[0]["subscribed"];
          // Unsubs
          this.subscribers.unsubs = response.data.data[0]["unsubscribed"];
          // Unsubs rate
          this.subscribers.unsubscribeRate = parseFloat(
            response.data.data[0]["unsubscribe_rate"]
          ).toFixed(2);
          // Patience Days
          this.subscribers.patienceDays = parseFloat(
            response.data.data[0]["avg_patient_days"]
          ).toFixed(2);
        })
        .catch((err) => {
          if (err.response !== undefined && (err.response.status === 419 || err.response.status === 401)) {
            this.logout().then(() => {
              localStorage.removeItem("auth");
              //localStorage.removeItem("login");
              this.$route.replace({
                name: "Login",
                path: this.$route.path,
              });
            });
          } else {
            this.error = err;
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        });
    },
    setDateRange() {
      switch (this.dateRange) {
        case "month":
          this.$set(this, "datePicker", [
            new Date(
              moment()
                .subtract(1, "months")
                .format("YYYY, MM, DD")
            ),
            new Date(moment().format("YYYY, MM, DD")),
          ]);
          break;
        case "week":
          this.$set(this, "datePicker", [
            new Date(
              moment()
                .subtract(1, "weeks")
                .format("YYYY, MM, DD")
            ),
            new Date(moment().format("YYYY, MM, DD")),
          ]);
          break;

        case "day":
          this.$set(this, "datePicker", [
            new Date(
              moment()
                .subtract(24, "hours")
                .format("YYYY, MM, DD")
            ),
            new Date(moment().format("YYYY, MM, DD")),
          ]);
          break;
      }
      this.getStatsData();
    },
    setIndexType(event) {
      this.indexType = event.target.innerText.toLowerCase();
    },
    getIndexTypeValue(property, percentage = false) {
      let value = null;

      switch (this.indexType.toLowerCase()) {
        case "welcome drip":
          value = this.welcome[property];
          break;
        case "recurring":
          value = this.recurring[property];
          break;
        case "total":
          value = this.total[property];
          break;
        case "dead list":
          value = this.deadList[property];
          break;
      }

      if (typeof value === "string") {
        value = parseFloat(value);
      }

      return percentage ? value.toFixed(2) : value;
    },
    getTheBestDrip(type, dateStart, dateEnd, dateTrunk, domainId) {
      return new Promise((resolve, reject) => {
        Statistics.getTheBestDripRequest(
          `date_start=${dateStart}&date_finish=${dateEnd}&domain_ids=${domainId}&date_trunc=${dateTrunk}&drip_type=${type}`
        )
          .then((response) => {
            resolve(response);
            this.getTheBestDripDataById(
              type,
              domainId,
              response.data.data[0].drip_id
            ).then(() => {
              this.theBestRecurring.push_ctr = response.data.data[0].push_ctr;
              this.theBestWelcome.push_ctr = response.data.data[0].push_ctr;
            });
          })
          .catch((err) => {
            reject(response);
            this.error = err;
          });
      });
    },
    getTheBestDripDataById(type, domainId, id) {
      return new Promise((resolve, reject) => {
        Drip.get(type, `?where[domain_id]=${domainId}&where[id]=${id}`)
          .then((response) => {
            resolve(response);
            if (type === "welcome") {
              this.theBestWelcome = response.data.data[0];
            } else if (type === "recurring") {
              this.theBestRecurring = response.data.data[0];
            }
          })
          .catch((err) => {
            reject(err);
            this.error = err;
          });
      });
    },
  },
  watch: {
    dateRange() {
      this.setDateRange();
    },
    datePicker: {
      handler(date) {
        this.loading = true;

        for (let type of ["recurring", "welcome", ""]) {
          this.getDripStatistics(
            date[0],
            date[1],
            this.$route.params.id,
            type,
            this.dateRange
          );
        }

        this.getSubStatistics(
          date[0],
          date[1],
          this.$route.params.id,
          this.dateRange
        );
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.loading-spinner {
  font-size: 5px;
  width: 24px;
  height: 24px;
}
</style>
